import styled from 'styled-components';

const Wrapper = styled.header`
  height: 80px;
  left: 0;
  max-width: 100%;
  padding: 10px 15px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/Header/Wrapper.js